module.exports = __webpack_public_path__ + "img/slonimskaya.da8cc3af.jpg";